import { apply, celebrate, onceToday, toast } from '../core/effects';
import { m } from '../i18n';
import { sfx } from '../audio/sfx';
import { h } from './dom';
import { closePanel, openPanel, refreshPanel } from './panel';
import { isSolved, shuffle, slide } from '../minigames/slider';

let tiles = shuffle();
let moves = 0;
let won = false;

export function openPuzzle(): void {
  tiles = shuffle();
  moves = 0;
  won = false;
  openPanel('puzzle', render);
}

function render() {
  const t = m().puzzle;
  return {
    title: t.title,
    body: [
      h('p', { class: 'hint' }, t.hint),
      h(
        'div',
        { class: `puzzle-board${won ? ' won' : ''}` },
        tiles.map((v, i) =>
          h(
            'button',
            {
              class: `puzzle-tile${v === 0 ? ' empty' : ''}`,
              style: v ? `--hue:${v * 40}` : '',
              disabled: v === 0 || won,
              'aria-label': String(v || ''),
              onclick: () => tap(i),
            },
            v ? String(v) : '',
          ),
        ),
      ),
      h('p', { class: 'hint center' }, t.moves(moves)),
    ],
    footer: [
      h(
        'button',
        {
          class: 'btn blue',
          onclick: () => {
            tiles = shuffle();
            moves = 0;
            won = false;
            sfx('pop');
            refreshPanel('puzzle');
          },
        },
        t.shuffle,
      ),
    ],
  };
}

function tap(i: number): void {
  const next = slide(tiles, i);
  if (!next) return;
  tiles = next;
  moves++;
  sfx('click');
  if (isSolved(tiles)) {
    won = true;
    toast(m().puzzle.solved);
    if (onceToday('puzzle')) {
      celebrate(true);
      apply({ stars: 10, coins: 20, mood: 10 });
    } else sfx('ok');
    window.setTimeout(() => closePanel('puzzle'), 1400);
  }
  refreshPanel('puzzle');
}
